import { memo } from 'react';
import { Flag } from '@namespace/icons2';

import styles from './index.module.css';

const ParticipantFlag = ({ className = '', country }) => (
  <Flag name={country} className={`${styles.flag} ${className}`} />
);

export default memo(ParticipantFlag);
